import { Inject } from '@odinjs/odin';

import { ProviderAccreditationPendenciesService } from '@philips-emr/hpms-provider-accreditation-commons';
import { FetchAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import BaseController from '../BaseController';

import { AccreditationSteps } from './provider-accreditation-controller';

@Controller ({ fragment: 'provider-accreditation-amount-professionals' })
export default class ProviderAccreditationAmountProfessionals extends BaseController {

  @Inject('fetch-amount-professionals')
  private fetchList: FetchAPI;
  @Inject('panel-pendencies')
  private panelPendencies: PanelAPI;
  @Inject('toast-notification')
  private toast: ToastNotificationAPI;

  @OnMount('layout-amount-professionals')
  onMountForm(): void {
    const { nrSeqUser, nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqAccreditation, nrSeqUser });
    this.fetchList.forceFetch();
  }

  @OnMount('fetch-pendencies')
  onMountFetch(event: MountEvent): void {
    ProviderAccreditationPendenciesService.fetchCardPendencies(event, AccreditationSteps.AMOUNT_PROFESSIONALS);
  }

  @OnAfterFetch('fetch-pendencies')
  onAfterFetch(event: FetchEvent): void {
    if(isEmptyArrayOrObject(event.data)){
      this.panelPendencies.setVisible(false);
    } else {
      ProviderAccreditationPendenciesService.setMessageToastPendency(this.toast, event);
    }
  }

}
